













import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import Button from '../../core/components/Button.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';


@Component({
    components: {
        Button,
    }
})
export default class PreloadIgnoredPeriods extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {

    @Prop({
        default() {
            return [];
        }
    })
    selectedWorkSegments: Array<object>;
    noSelectedWorkSegment: string = 'Debe seleccionar al menos 1 segmento de trabajo';
    addNewPeriodMsg: string = 'Agregar Período Ignorado';

    // get existResowingPeriod(){
    //     return this.forcedPeriods.length !== 0 ? true : false
            
    // }

    get getAddPeriodTooltip(){
         if(!this.existSelectedWorkSegment){
            return this.noSelectedWorkSegment
        }
        return  this.addNewPeriodMsg
    }

    get existSelectedWorkSegment(){
        return this.selectedWorkSegments.length < 1 ? false : true
    }

    get canAddNewPeriod(){
        if(this.getAddPeriodTooltip === this.addNewPeriodMsg){
            return true
        }
        return false
    }

    @Emit()
    addNewIgnorePeriod(){}
}
